// extracted by mini-css-extract-plugin
export default {"infoRowCon":"ModalInfoRow_infoRowCon__uLXiq"};